<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<app-text-field [fg]="form" formGroupOrControlName="search" label=" " placeholder="Search..."></app-text-field>
	<app-search-button>Search</app-search-button>
</form>
